import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, OnInit, ViewChild, computed, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, finalize } from 'rxjs';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {animate, state, style, transition, trigger} from '@angular/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatInputModule } from '@angular/material/input';
import * as XLSX from 'xlsx';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';
import { ErrorLogService } from '../service/errorLogService';

export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-accountpage',
    imports: [SharedTranslateModule, MatInputModule, SessionTimeoutComponent,MatTableModule, MatPaginator, MatSort, MatSortModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, FormsModule, MatButtonToggleModule],
    templateUrl: './accountdetails.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class AccountdetailsComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  hideSingleSelectionIndicator=true;
  accountRedirect = '';
  token: string;
  brandId: string;
  loginAttempt = false;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  readonly isCanadaPortal = signal(false);
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  readonly bodyLoaded = signal(false);
  readonly dbLoaded = signal(false);
  private readonly pendingRequests = signal(0);
  readonly tableLoaded = computed(() => this.pendingRequests() === 0);
  readonly isFrench = signal(false);
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount ='';
  totalDue ='';
  ciamId = sessionStorage.getItem('loginID');
  readonly accountDetailsRes = signal<AccoutDetailsResponse[]>([]);
  readonly termAccDetailsRes = signal<AccoutDetailsResponse[]>([]);
  readonly maturedAccList = signal<AccoutDetailsResponse[]>([]);
  readonly expandedAccount = signal<AccoutDetailsResponse | null>(null);
  //used for mat-toggle
  toggleEnum = ToggleEnum;
  readonly selectedState = signal<ToggleEnum | undefined>(ToggleEnum.Option6);
  private readonly accountGroup = signal(ToggleEnum.Option6);
  private readonly searchTerm = signal('');
  private readonly destroyRef = inject(DestroyRef);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly errorLogService = inject(ErrorLogService);
  private accountsDisplayChecked = false;
  
  // Table columns
  initColumns: any[] = [
    {
      name: 'contractNum',
      display: 'Account',
      displayFR: 'Numéro de contrat',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Account Type',
      displayFR: 'Type de contrat',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
   {
      name: 'status',
      display: 'Status',
      displayFR: 'Statu',
      dispFormat: ''
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  filterActive = false;
  readonly filter = signal(false);
  readonly filteredAccounts = computed(() => {
    const group = this.accountGroup();
    const accounts = group === ToggleEnum.Option3 ? this.maturedAccList()
      : group === ToggleEnum.Option4 ? this.termAccDetailsRes() : this.accountDetailsRes();
    const query = this.searchTerm();
    return accounts.filter(account =>
      account.contractNum.toLowerCase().includes(query) ||
      account.status.toLowerCase().includes(query) ||
      account.contractType.toLowerCase().includes(query));
  });
  readonly rowCount = computed(() => this.filteredAccounts().length);
  readonly totalFilteredCost = computed(() =>
    this.filteredAccounts().reduce((total, account) => total + Number(account.totalDue), 0));
  value = '';


  readonly dataSource = new MatTableDataSource<AccoutDetailsResponse>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  constructor(router: Router,private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
              private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil

    ){
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    effect(() => {
      this.dataSource.data = this.filteredAccounts();
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    this.selectedState.set(undefined); //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchTerm.set(filterValue.trim().toLowerCase());
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
       
  onChange(event: MatButtonToggleChange) {
    const selected: ToggleEnum = event.value;
    this.selectedState.set(selected);
    this.accountGroup.set(selected);
    this.searchTerm.set(selected === ToggleEnum.Option1 ? 'loan'
      : selected === ToggleEnum.Option2 ? 'lease'
      : selected === ToggleEnum.Option5 ? 'dynamic' : '');
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    return this.dataSource;

  }

  ngOnInit() {
    sessionStorage.removeItem('amortAccount');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(val => {
        this.isCanadaPortal.set(val === APP_CONSTANTS.COUNTRY_CA);
        this.currentCountry = val;
    });
    this.isFrench.set('fr-CA' === language); //checks if language is french or english for Canada

    this.getAccountDetailsListByUserId();
    this.getTerminatedAccounts();
    this.getMaturedAccounts();
  }

  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }

  checkUrlParam(redirect: string, account: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('amortAccount', account);
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //       if( this.currentCountry === 'CA'){
  //         if (res[i].bannerType === 'Alert' &&  res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //         res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //         this.alerts = res[i];
  //         this.dbData = true;
  //          }
  //       }
  //       else{
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       }
  //     });
  // }

  formatAccountURl(redirect: string) {
    this.bodyLoaded.set(true);
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
          if (redirect === 'insurance'){
            this.azURL =  this.usUrl + '/ca/fr/home/insurance';
          }
          else if (redirect === 'payoff'){
            this.azURL =  this.usUrl + '/ca/fr/home/payoff';
          }
          else if (redirect ==='amortization'){
            this.azURL =  this.usUrl + '/ca/fr/home/amortization';
          }
          else if (redirect ==='documentcenter'){
            this.azURL =  this.usUrl + '/ca/fr/home/documentcenter';
          }
      }
      else{
        if (redirect === 'insurance'){
          this.azURL =  this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'payoff'){
          this.azURL =  this.usUrl + '/ca/en/home/payoff';
        }
        else if (redirect ==='amortization'){
          this.azURL =  this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect ==='documentcenter'){
          this.azURL =  this.usUrl + '/ca/en/home/documentcenter';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'insurance'){
        this.azURL =  this.usUrl + '/home/insurance';
      }
      if (redirect === 'payoff'){
        this.azURL =  this.usUrl + '/home/payoff';
      }
      if (redirect === 'dynamic'){
        this.azURL =  this.usUrl + '/home/dynamicdashboard';
      }
      if (redirect === 'pay'){
        this.azURL =  this.usUrl + '/home/pay';
      }
      else if (redirect ==='amortization'){
        this.azURL =  this.usUrl + '/home/amortization';
      }
      else if (redirect ==='documentcenter'){
        this.azURL =  this.usUrl + '/home/documentcenter';
      }
      // else if (redirect ==='invoice'){
      //   this.azURL =  this.usUrl + '/home/invoice';
      // }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
  }, 1000);  //1s
  }

  getAccountDetailsListByUserId() {
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.trackRequest(this.auth.getAccountDetailsListByUserId(accountDetailsRequest)).subscribe({
    next: res => {
      this.accountDetailsRes.set(res.accountdetailsList);
      this.dbLoaded.set(true);
      this.filter.set(true);
    },
    error: err => console.error('Failed to load account details', err)
  });
}

getTerminatedAccounts() {
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.trackRequest(this.auth.getTerminatedAccounts(accountDetailsRequest)).subscribe({
    next: res => this.termAccDetailsRes.set(res.accountdetailsList),
    error: err => console.error('Failed to load terminated accounts', err)
  });
}
getMaturedAccounts() {
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.trackRequest(this.auth.getMaturedAccounts(accountDetailsRequest)).subscribe({
    next: res => this.maturedAccList.set(res.accountdetailsList),
    error: err => console.error('Failed to load matured accounts', err)
  });
}

private trackRequest(request: Observable<{ accountdetailsList: AccoutDetailsResponse[] }>) {
  this.pendingRequests.update(count => count + 1);
  return request.pipe(
    takeUntilDestroyed(this.destroyRef),
    finalize(() => {
      this.pendingRequests.update(count => count - 1);
      if (this.pendingRequests() === 0) {
        setTimeout(() => this.verifyAccountsDisplayed());
      }
    })
  );
}

private verifyAccountsDisplayed(): void {
  if (this.accountsDisplayChecked || this.destroyRef.destroyed || this.bodyLoaded() || !this.tableLoaded()) {
    return;
  }
  this.accountsDisplayChecked = true;
  const rowsDisplayed = this.elementRef.nativeElement.querySelectorAll('.example-element-row').length;
  if (rowsDisplayed === 0) {
    this.errorLogService.logValidationError('Account Details', 'accountdetailsList', 'User screen has not displayed account details',
      undefined, this.loggedInUserId());
  }
}

exportToExcel(): void {
  try {
    this.writeAccountsToExcel();
  } catch (err) {
    console.error('Failed to export account details to Excel', err);
    this.errorLogService.logValidationError('Account Details', 'exportToExcel',
      `Export to Excel download failed: ${err instanceof Error ? err.message : String(err)}`, undefined, this.loggedInUserId());
  }
}

private loggedInUserId(): string | undefined {
  return this.ciamId || sessionStorage.getItem('loginID') || undefined;
}

private writeAccountsToExcel(): void {
  const fileName = `AccountDetails_${new Date().toISOString()}.xlsx`;

  // ✅ Select header labels (English or French)
  const header = this.initColumns.map(col =>
    this.isFrench() ? col.displayFR : col.display
  );

  // ✅ Get actual data from MatTableDataSource
  const dataArray = this.filteredAccounts();

  // ✅ Map data (only currency formatted)
  const data = dataArray.map(row => {
    const obj: any = {};
    this.initColumns.forEach(col => {
      const headerLabel = this.isFrench() ? col.displayFR : col.display;

      if (col.dispFormat === 'currency') {
        const value = row[col.name];
        // Format as $1,234.56 (with commas)
        obj[headerLabel] = value !== null && value !== undefined && !isNaN(value)
          ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : '';
      } else {
        obj[headerLabel] = row[col.name];
      }
    });
    return obj;
  });

  // ✅ Create worksheet and workbook
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'AccountDetails');

  // ✅ Save Excel file
  XLSX.writeFile(wb, fileName);
}



}
